<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form ref="searchForm">
                    <c-form-item type="input" label="申请单号" name="apply_number"></c-form-item>
                    <c-form-item type="input" label="手机号" name="user_manage_mobilephone"></c-form-item>
                    <c-form-item type="input" label="公司名称" name="company_name"></c-form-item>
                    <c-form-item type="datetime" label="申请时间" start-name="start_date" end-name="end_date"></c-form-item>
                    <c-form-item type="checkbox" label="状态" name="state" :options="State" ></c-form-item>
                </c-form>
            </m-search>

            <m-operate>
                <c-button color="sys" power="b_credit_quota_add"  @click="add">新增授权用户</c-button>
            </m-operate>

            <c-table ref="table" code="credit_quota_list">
                <c-table-column
                    label="申请单号"
                    name="apply_number"
                    width="120"
                ></c-table-column>

                <c-table-column
                    label="状态"
                    name="state"
                    width="70"
                >
                    <template v-slot="{data}">
                      <span style="color:red" v-if="data.state==0">{{stateName[data.state]}}</span>
                      <span style="color:dodgerblue" v-if="data.state==1">{{stateName[data.state]}}</span>
                      <span style="color:green" v-if="data.state==2">{{stateName[data.state]}}</span>
                      <span style="color:#999999" v-if="data.state==-1">{{stateName[data.state]}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                      label="申请金额"
                      name="credit_money"
                      width="80"
                >
                  <template v-slot="{data}">
                    <span style="color:dodgerblue" v-if="data.credit_money && data.credit_money>0">￥{{data.credit_money.toFixed(2)}}</span>
                    <span v-else>--</span>
                  </template>
                </c-table-column>

                <c-table-column
                        label="会员名称"
                        name="nick_name"
                        width="100"
                >
                  <template v-slot="{data}">
                    <span v-if="data.nick_name && data.nick_name!=''">{{data.nick_name}}</span>
                    <span v-else>--</span>
                  </template>
                </c-table-column>

                <c-table-column
                        label="手机号"
                        name="user_manage_mobilephone"
                        width="100"
                >
                  <template v-slot="{data}">
                    <span v-if="data.user_manage_mobilephone && data.user_manage_mobilephone!=''">{{data.user_manage_mobilephone}}</span>
                    <span v-else>--</span>
                  </template>
                </c-table-column>

                <c-table-column
                        label="申请人"
                        name="apply_name"
                        width="100"
                ></c-table-column>

                <c-table-column
                        label="申请时间"
                        name="create_date"
                        width="130"
                ></c-table-column>

                <c-table-column
                        label="审核人  "
                        name="approval_name"
                ></c-table-column>

                <c-table-column
                        label="审批时间"
                        name="audit_date"
                        width="130"
                ></c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="120"
                >
                    <template v-slot="{data}">
                        <c-table-button v-if="data.state != 0" @click="navigateTo(`/credit_quota_detail/${data.id}`)">查看</c-table-button>
                        <c-table-button v-if="data.state <= 0" power="b_credit_quota_edit" @click="edit(data)">编辑</c-table-button>
<!--                        <c-table-button v-if="data.state <= 0" @click="del(data)">删除</c-table-button>-->
                        <c-table-button v-if="data.state == 1" @click="navigateTo(`/credit_quota_detail/${data.id}`)">审核</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>

        <c-dialog ref="uEdit" :title="editState ? '编辑授信额度' : '申请授信额度'" width="600" >
            <c-form ref="uForm">
                <c-form-item type="hidden" name="id"></c-form-item>
                <c-form-item type="hidden" name="platform_user_id"></c-form-item>
                <c-form-item type="input" label="手机号" name="user_manage_mobilephone" required readonly @click="$refs.memberSelector.open()"></c-form-item>
                <c-form-item type="input" label="昵称" name="nick_name" required readonly></c-form-item>
                <c-form-item type="number" label="申请金额" name="credit_money" decimal="2" required></c-form-item>
                <c-form-item type="textarea" label="申请说明" name="remark" required></c-form-item>
            </c-form>

            <template slot="button">
                <c-button size="m" @click="submit(0)">保存为草稿</c-button>
                <c-button size="m" @click="submit(1)">保存并提交</c-button>
                <c-button size="m" @click="$refs.uEdit.close()">取消</c-button>
            </template>
        </c-dialog>

        <member-selector ref="memberSelector" @resolve="selectMember"></member-selector>
    </page>
</template>

<script>
    import memberSelector from '@/components/service/member_selector.vue'  // 会员库
    export default {
        name: 'm_credit_quota',
        components: {
            memberSelector
        },

        props: {
            state: String
        },

        data() {
            return {
                stateName: {
                    0: '草稿',
                    1: '待审核',
                    2: '审批通过',
                    '-1': '驳回'
                },
                State: [{
                    name: '草稿',
                    value: 0
                },{
                    name: '待审核',
                    value: 1
                },{
                    name: '审批通过',
                    value: 2
                },{
                    name: '驳回',
                    value: '-1'
                }
                ],
                editState: false
            }
        },

        computed: {
            defaultSearch() {
                let param = {
                    state: this.state ? this.state.split(',') : [],
                }

                return param;
            }
        },

        watch: {
            defaultSearch(val) {
                this.$refs.searchForm.set(val);
                this.$nextTick(() => {
                    this.$refs.search.search();
                })
            }
        },

        mounted() {
            this.$refs.searchForm.set(this.defaultSearch);
            this.$nextTick(() => {
                this.$refs.search.search();
            })
            this.$bus.$on('credit_quota.update', data => {
                // 刷新列表
                this.$refs.table.update();
            });

        },

        methods: {
            searchHandle(data) {
                this.$refs.table.load({
                    url: '/credit_quota/list',
                    data
                });
            },
            add(stop) {
                this.editState = false;
                this.$refs.uForm.clear();
                this.$refs.uEdit.open();
            },
            edit(val) {
                this.editState = true;
                this.$refs.uForm.set(val);
                this.$refs.uEdit.open();
            },
            del(val) {
                this.$confirm({
                    text: '确定要删除【'+val.apply_number+'】吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/credit_quota/delete',
                            data: {id:val.id},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },
            selectMember(data) {
                this.$refs.uForm.set({
                    platform_user_id: data[0].platform_user_id,
                    user_name: data[0].login_name,
                    user_manage_mobilephone: data[0].user_manage_mobilephone
                });
            },
            submit(state) {
                let submitUrl = '/credit_quota/add';
                if(this.editState){
                    submitUrl = '/credit_quota/edit';
                }
                this.$refs.uForm.submit({
                    url: submitUrl,
                    rule: {
                        platform_user_id: [{
                            type: 'empty',
                            word: '请选择会员'
                        }],

                        credit_money: [{
                            type: 'credit_money',
                            word: '请输入金额'
                        }],

                        remark: [{
                            type: 'empty',
                            word: '请填写备注信息'
                        }]
                    },
                    dataFormatter: data => {
                        data.state = state;
                        return data;
                    },
                    success:(data,res) => {
                        this.$message({
                            text: '操作成功',
                            icon: 'success'
                        });
                        this.$refs.table.update();
                        this.$refs.uEdit.close();
                    },
                });
            }
        }
    }
</script>